import { createSlice } from '@reduxjs/toolkit'

import { setApiError } from 'src/Hooks/redux'
import { ApiError, NameSpace, SliceStatus } from 'src/Redux/types'

import { deleteArtistAccount } from './api-actions'

export interface ArtistDeleteAccountState {
  status: SliceStatus
  error: ApiError | null
}
const initialState: ArtistDeleteAccountState = {
  status: SliceStatus.Idle,
  error: null,
}

export const artistDeleteAccountSlice = createSlice({
  initialState,
  name: NameSpace.ArtistDeleteAccount,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(deleteArtistAccount.pending, (state) => {
      state.status = SliceStatus.Loading
    })
    builder.addCase(deleteArtistAccount.fulfilled, (state) => {
      state.status = SliceStatus.Succeeded
    })
    builder.addCase(deleteArtistAccount.rejected, (state, action) => {
      state.status = SliceStatus.Failed
      state.error = setApiError(action)
    })
  },
})
